import request from '../utils/request'

/**
 * 首页相关接口
 */

// 获取轮播图列表
export function getBanners() {
  return request({
    url: '/h5/goods/banners',
    method: 'get'
  })
}

// 获取分类导航
export function getCategories() {
  return request({
    url: '/h5/goods/categories',
    method: 'get'
  })
}

// 获取推荐商品列表
export function getRecommendGoods(params) {
  return request({
    url: '/h5/goods/recommend',
    method: 'get',
    params
  })
}

// 获取全部商品列表（暂不分类，首页用）
export function getAllGoods(params) {
  return request({
    url: '/h5/goods/list',
    method: 'get',
    params
  })
}

// 搜索商品
export function searchGoods(params) {
  return request({
    url: '/h5/goods/list',
    method: 'get',
    params
  })
}
